import { initialState as initialTranslationsState } from '../Translations';
import { initialState as initialExperimentsState } from '../Experiments';
import { initialState as initialOnboardingProgressState } from '../OnboardingProgress';
import { initialState as initialPortalState } from '../Portal';
import { initialState as initialPortalAttributesState } from '../PortalAttributes';
import { initialState as initialNavItemsState } from '../navItems';
import { initialState as businessUnitsInitialState } from '../BusinessUnits';
import { initialState as userInitialState } from '../User';
import { initialState as initialTrellisState } from '../Trellis';
import { initialState as appConfigInitialState, initialState } from '../AppConfig';
import { initialState as alertsInitialState } from '../Alerts';
import { getNormalizedNavItems } from './navItems';
import { getPortalAttributes, getPortalUserAttributes } from './portalAttributes';
import getIsVerticalNavEnabledForTheCurrentPath from '../../utils/getIsVerticalNavEnabledForTheCurrentPath';
import getNavType from '../../utils/getNavType';
import { initialOverlayConfigState } from '../../overlayDisplayConfig/reducer';
import { initialState as navLayoutDimensionsInitialState } from '../../NavLayoutDimensions/constants';
import { getNavWidthFromNavConfig } from '../../NavLayoutDimensions/utils/getInitialNavWidth';
import { globalStylesAdapter, globalStylesSliceName } from '../GlobalStyles';
import { initialPortalUserAttributesState } from '../portalUserAttributes';
import { getStoreWithBookmarks } from './bookmarks';
import { initialNavObjBuilderMenuState, navObjBuilderMenu } from '../../components/ObjectCreateButton/reducer';
import { maybeMoveGlobalHomePrimaryNavItem } from './globalHome';
import { inAppHelpInitialState, inAppHelpSliceName } from '../../external-contrib/in-app-help/reducers';
import { initialAccountsDataState, accountsDataSliceName } from '../AccountsData';
import { iaDetailsSliceName } from '../iaDetails.slice';
import { plpoExperienceSliceName, initialPLPODataState } from '../PLPOExperience';
import merge from 'hs-lodash/merge';
import { NavType } from '../../constants';
import { defaultHomeSliceName, initialDefaultHomeState } from '../../features/global-home-onboarding-tour/slices/default-home.slice';
import { initialState as initialCreditsState } from '../Credits';
import { initialNavOnboardingTourHoverState, navOnboardingTourHoverSliceName } from '../../features/nav-onboarding-tours/slices/NavOnboardingTourHover.slice';
export const initialStore = {
  navItems: initialNavItemsState,
  portal: initialPortalState,
  user: userInitialState,
  translations: initialTranslationsState,
  portalAttributes: initialPortalAttributesState,
  portalUserAttributes: initialPortalUserAttributesState,
  experiments: initialExperimentsState,
  onboardingProgress: initialOnboardingProgressState,
  businessUnits: businessUnitsInitialState,
  appConfig: appConfigInitialState,
  overlayDisplayConfigState: initialOverlayConfigState,
  navLayoutDimensionsState: navLayoutDimensionsInitialState,
  [globalStylesSliceName]: globalStylesAdapter.getInitialState(),
  alerts: alertsInitialState,
  [navObjBuilderMenu]: initialNavObjBuilderMenuState,
  [inAppHelpSliceName]: inAppHelpInitialState,
  [accountsDataSliceName]: initialAccountsDataState,
  [iaDetailsSliceName]: {},
  [plpoExperienceSliceName]: initialPLPODataState,
  [defaultHomeSliceName]: initialDefaultHomeState,
  credits: initialCreditsState,
  trellis: initialTrellisState,
  [navOnboardingTourHoverSliceName]: initialNavOnboardingTourHoverState
};
export const mergeWith = patch => state => merge({}, state, patch);
export const applyFallbackNav = mergeWith({
  appConfig: {
    navType: NavType.FALLBACK
  }
});
const hydrateStore = navConfigResponse => {
  const {
    user,
    translations
  } = navConfigResponse;
  let store = Object.assign({}, initialStore, {
    user: Object.assign({}, initialStore.user, user),
    translations,
    appConfig: Object.assign({}, initialStore.appConfig, {
      navType: getNavType(navConfigResponse)
    }),
    navLayoutDimensionsState: Object.assign({}, initialStore.navLayoutDimensionsState, {
      rootNav: Object.assign({}, initialStore.navLayoutDimensionsState.rootNav, {
        VerticalNav: Object.assign({}, initialStore.navLayoutDimensionsState.rootNav.VerticalNav, {
          width: getNavWidthFromNavConfig(navConfigResponse)
        })
      })
    }),
    [iaDetailsSliceName]: Object.assign({}, 'iaDetails' in navConfigResponse ? navConfigResponse.iaDetails : {}),
    [plpoExperienceSliceName]: initialPLPODataState,
    [defaultHomeSliceName]: initialDefaultHomeState
  });
  if ('portal' in navConfigResponse) {
    const {
      portal,
      navPersona,
      experimentStatuses,
      enrolledInUserGuide,
      businessUnits,
      objectCreateButtonOptions
    } = navConfigResponse;
    const navItems = getNormalizedNavItems(navConfigResponse);
    store = getStoreWithBookmarks(Object.assign({}, store, {
      user: Object.assign({}, store.user, {
        enrolledInUserGuide
      }),
      navItems,
      portal,
      portalAttributes: getPortalAttributes(navPersona),
      portalUserAttributes: getPortalUserAttributes(navPersona),
      experiments: experimentStatuses && experimentStatuses.experiments ? experimentStatuses.experiments : store.experiments,
      businessUnits,
      appConfig: Object.assign({}, store.appConfig, {
        displayFeedbackModal: undefined,
        isVerticalNavEnabled: getIsVerticalNavEnabledForTheCurrentPath({
          verticalNavExclusionRoutes: navItems.verticalNavExclusionRoutes
        }),
        navExtensionTriggers: navConfigResponse.navExtensionTriggers || initialState.navExtensionTriggers
      }),
      [navObjBuilderMenu]: {
        items: objectCreateButtonOptions
      }
    }));
    store = maybeMoveGlobalHomePrimaryNavItem({
      navConfigResponse,
      store
    });
  }
  return store;
};
export default hydrateStore;